module.exports = __webpack_public_path__ + "static/media/search.f28c2019.svg";